<template>
  <section class="privilege-group">
    <viewTitle title="权限管理 / 权限组配置" :showReturn="false"></viewTitle>
    <!-- 按钮组 -->
    <section class="controler">
      <div style="display: flex;">
        <el-button type="primary" size="small" @click="createGroup">
          新增权限组
        </el-button>
        <div class="lc">
          <el-input
            placeholder="请输入要搜索的角色名称"
            v-model="params.keyword"
            clearable
            @change="changeKeyword"
            suffix-icon="el-icon-search"
            style="width: 210px;"
          >
          </el-input>
        </div>
      </div>
    </section>
    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        :data="tableData"
        show-overflow-tooltip
        cell-class-name="table-cell"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        :border="true"
      >
        <el-table-column label="角色名称" width="180">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="管理员" width="400">
          <template slot-scope="scope">
            {{ scope.row.admin_fix || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="描述">
          <template slot-scope="scope">
            <template v-if="scope.row.description.length > 0">
              <span>{{ scope.row.description }}</span>
            </template>
            <template v-else>
              <span>--</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item @click.native.stop="edit(scope.row)"
                    >修改</el-dropdown-item
                  >
                  <el-dropdown-item @click.native.stop="del(scope.row)"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="params.page"
          :pageSize="params.page_size"
          :count="params.count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>
  </section>
</template>

<script>
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import confirm from "@/components/elementPlus/packages/confirm";
export default {
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        page_size: 20,
        count: 0
      },
      tableData: [],
      maxSize: 0,
      loading: false
    };
  },
  components: {
    pagi,
    viewTitle
  },
  mixins: [mixinTableLyout],
  computed: {},

  created() {
    this.initWatcher();
    this.fetchList();
  },

  activated() {
    this.fetchList();
  },

  mounted() {},

  methods: {
    fetchList() {
      if (!this.loading) {
        this.loading = true;
        this.$common
          .http({
            url: "/api/role/search_by_page",
            data: this.params
          })
          .then(res => {
            this.loading = false;
            let data = res.data.data;
            let { total, total_page, items } = data;
            console.log(total, total_page, items);
            this.params.count = total;
            // if (list_info.now_page > total_page) {
            //   this.params.page--;
            //   this.fetchList();
            //   return;
            // }
            this.convertData(items);
            this.tableData = items;
          });
      }
    },
    changeKeyword() {
      this.params.page = 1;
      this.fetchList();
    },
    createGroup() {
      this.$router.push("/rhqy/pri/app/index/edit");
    },
    edit({ id }) {
      this.$router.push("/rhqy/pri/app/index/edit/" + id);
    },
    del({ id }) {
      confirm({
        confirmAc: () => {
          this.$common
            .http({
              mt: "post",
              url: "/api/role/delete",
              data: {
                id
              }
            })
            .then(() => {
              this.$common.pcToastSuccess("删除成功");
              this.fetchList();
            });
        },
        confirmAcClass: "btnConfirmDanger",
        cancelAcClass: "btnCancel"
      });
    },
    pageChange(page) {
      this.params.page = page;
      this.fetchList();
    },
    initWatcher() {
      // const keys = ["params.keyword"];
      // keys.forEach(item => {
      //   this.$watch(
      //     item,
      //     qySebounce(() => {
      //       this.params.page = 1;
      //       this.fetchList();
      //     }, 200)
      //   );
      // });
    },
    convertData(data) {
      // 管理员格式化
      data.forEach(item => {
        let admin_fix = ``;
        item.bind_depts.forEach(admin => {
          admin_fix += `${admin.name};`;
        });
        item.bind_tags.forEach(admin => {
          admin_fix += `${admin.name};`;
        });
        item.bind_users.forEach(admin => {
          admin_fix += `${admin.name};`;
        });
        admin_fix = admin_fix.substring(0, admin_fix.length - 1);
        item.admin_fix = admin_fix;
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.privilege-group {
  padding: 16px 16px 0 16px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  .controler {
    display: flex;
    margin: 0 0 10px 0;
    justify-content: space-between;
  }
  .lc {
    margin-left: 15px;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
</style>
<style lang="less">
.privilege-group {
  .el-input__icon {
    line-height: 30px !important;
  }
  .el-input-group {
    width: 240px;
  }
}
</style>
